export default {"src":"/_next/static/media/Ollie_Site_Icons_working_final_EmployeeFairWage.12a2ce62.svg","height":70,"width":69,"blurWidth":0,"blurHeight":0};